module.exports = __webpack_public_path__ + "img/grey-triangle-r.3a696edc.png";